import { Tabs } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PageHeader } from "../components/PageHeader";
import { PatientsIndividualsPage } from "./PatientsIndividualsPage";
import { CaretakersIndividualsPage } from "./CaretakersIndividualsPage";
import { DoctorsIndividualsPage } from "./DoctorsIndividualsPage";
import { FamilyMemberIndividualsPage } from "./FamilyMembersIndividualsPage";

export const IndividualsPage = () => {
    const [activeTabKey, setActiveTabKey] = useState<string>("1");
    const { t } = useTranslation();

    return (
        <>
            <PageHeader title={t("page.individuals.title")} />
            <Tabs
                defaultActiveKey={activeTabKey}
                type="line"
                onChange={key => setActiveTabKey(key)}
            >
                <Tabs.TabPane tab={t("page.individuals.tab.patients")} key="1">
                    <PatientsIndividualsPage />
                </Tabs.TabPane>
                <Tabs.TabPane tab={t("page.individuals.tab.familyMembers")} key="3">
                    <FamilyMemberIndividualsPage />
                </Tabs.TabPane>
                <Tabs.TabPane tab={t("page.individuals.tab.caretakers")} key="2">
                    <CaretakersIndividualsPage />
                </Tabs.TabPane>
                <Tabs.TabPane tab={t("page.individuals.tab.doctors")} key="4">
                    <DoctorsIndividualsPage />
                </Tabs.TabPane>
            </Tabs>
        </>
    );
}
